class MetafieldsTableCategory extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.metafields-table__category-toggle');
    this.content = this.querySelector('.metafields-table__category-content');
  }

  connectedCallback() {
    if (!this.toggle || !this.content) return;

    // Set up toggle functionality
    this.toggle.addEventListener('click', this.handleToggle.bind(this));

    // Only set up hover effects if enabled via settings
    const hoverEnabled = this.dataset.hoverEnabled === 'true';
    if (hoverEnabled) {
      this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    }

    // Initialize state
    this.updateContentHeight();
  }

  handleToggle() {
    const isActive = this.classList.contains('active');

    if (isActive) {
      this.classList.remove('active');
      this.collapseContent();
    } else {
      this.classList.add('active');
      this.expandContent();
    }
  }

  expandContent() {
    this.content.style.height = this.content.scrollHeight + 'px';
  }

  collapseContent() {
    this.content.style.height = '0px';
  }

  updateContentHeight() {
    if (this.classList.contains('active')) {
      this.content.style.height = this.content.scrollHeight + 'px';
    } else {
      this.content.style.height = '0px';
    }
  }

  handleMouseEnter() {
    this.classList.remove('metafields-table__category--opacity');

    // Add opacity to siblings
    const siblings = Array.from(this.parentElement.children).filter(
      child => child !== this && child.tagName === 'METAFIELDS-TABLE-CATEGORY'
    );
    siblings.forEach(sibling => sibling.classList.add('metafields-table__category--opacity'));
  }

  handleMouseLeave() {
    // Remove opacity from all siblings
    const siblings = Array.from(this.parentElement.children).filter(
      child => child.tagName === 'METAFIELDS-TABLE-CATEGORY'
    );
    siblings.forEach(sibling => sibling.classList.remove('metafields-table__category--opacity'));
  }
}

customElements.define('metafields-table-category', MetafieldsTableCategory);

// Handle section reload
document.addEventListener('shopify:section:load', function(event) {
  const categories = event.target.querySelectorAll('metafields-table-category');
  categories.forEach(category => {
    if (category.updateContentHeight) {
      category.updateContentHeight();
    }
  });
});
